import { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import Modal from "react-bootstrap/Modal";
import { Search, XLg, ThreeDotsVertical } from "react-bootstrap-icons";
import { Dropdown, Button, Alert, Image, Row, Col } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import WardValidation from "../../../../hooks/WardValidation";
import {
  availableBedsList,
  reserveBed,
} from "../../../../store/actions/bedsAction";
import ButtonGroup from "react-bootstrap/ButtonGroup";
import ToggleButton from "react-bootstrap/ToggleButton";
import ManageWard from "../ManageWard";
import grayBox from "../../../../assets/images/grayBox.png";
import greenBox from "../../../../assets/images/greenBox.png";
import blueBox from "../../../../assets/images/blueBox.png";
import EditImg from "../../../../assets/images/edit.png";
import ProfileImage from "../../../../assets/images/profile.svg";
import Loader from "../../../common/loader/Loader";
import ApiResponsePopup from "../../../common/modal/ApiResponsePopup";
import styles from "../../../common/modal/Popup.module.css";
import ManageOccupy from "./ManageOccupy";
import { resetPopup, userReset } from "../../../../store/reducerSlice/clients";
// card
import Card from "react-bootstrap/Card";
import availableWard from "../../../../assets/images/availableWard.png";
import redBox from "../../../../assets/images/red.png";
import yellowBox from "../../../../assets/images/yellow.png";
import greenBed from "../../../../assets/images/greenBed.png";
// card
const AvailableBeds = () => {
  const { wardId } = useParams();
  const [show, setShow] = useState(false);
  const [isShow, setIsShow] = useState(false);
  const [show1, setShow1] = useState(false);
  //
  const dispatch = useDispatch();
  const [nhsNumber, setNhsNumber] = useState(null);
  const [patientInitials, setPatientInitials] =useState(null);
  const [isActionCalled, setIsActionCalled] = useState(false);
  const [isDone, setIsDone] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  const handleClose1 = () => {
    setShow1(false);
    setNhsNumber(null);
    setPatientInitials(null);
  };
  const handleShow1 = () => setShow1(true);

  const {
    isBedRecordUpdated,
    error: apiError,
    isLoader,
    availableBeds,
  } = useSelector((state) => state.beds);
  const { isRecordUpdated } = useSelector((state) => state.wards);

  const [error, checkValidator, resetValidator, resetAllValidator, isError] =
    WardValidation({
      nhsNumber: nhsNumber,
    });

  useEffect(() => {
    if (isBedRecordUpdated || isRecordUpdated) {
      dispatch(availableBedsList({ wardId })).then(({ payload }) => {
        if (payload?.success) {
          console.log("payload?.data", payload?.data);
          hideHandlerRes();
        } else {
          setIsShow(true);
        }
      });
    }
  }, [isBedRecordUpdated, isRecordUpdated]);

  useEffect(() => {
    dispatch(availableBedsList({ wardId })).then(({ payload }) => {
      if (payload?.success) {
        console.log("payload?.data", payload?.data);
        hideHandlerRes();
      } else {
        setIsShow(true);
      }
    });
  }, []);

  const submitHandler = (e) => {
    console.log("action called");
    e.preventDefault();
    checkValidator();
    setIsActionCalled(true);
  };

  useEffect(() => {
    if (!isError() && error !== null && isActionCalled) {
      dispatch(reserveBed({ nhsNumber: nhsNumber, wardId: wardId,patientInitials:patientInitials })).then(
        ({ payload }) => {
          if (payload.success) {
            hideHandlerRes();
            handleClose1();
          } else {
            setIsDone(true);
            setIsShow(true);
          }
        }
      );
      setIsActionCalled(false);
    } else {
      setIsActionCalled(false);
    }
  }, [isActionCalled]);

  const hideHandlerRes = () => {
    setIsShow(false);
  };

  return (
    <>
      <ManageOccupy show={show} onHide={handleClose} title={"Occupy Bed"} />

      {/* Modal Reserve */}
      <Modal
        show={show1}
        onHide={handleClose1}
        aria-labelledby="contained-modal-title-vcenter"
        className={styles.modal}
        centered
      >
        <Modal.Header closeButton>
          {" "}
          <h4 align="center" style={{ textAlign: "center", flex: "auto" }}>
            Reserve
          </h4>
        </Modal.Header>
        <Modal.Body className="px-5">
          
          <Form.Group className="mb-3">
            <Form.Label>Enter NHS Number</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter NHS number"
              autoFocus
              name="nhsNumber"
              maxlength="10"
              value={nhsNumber}
              onChange={(e) => {
                setNhsNumber(e.target.value);
                resetValidator(e.target.name);
              }}
              isInvalid={error && error?.nhsNumber}
            />
            <Form.Control.Feedback type="invalid">
              {error && error?.nhsNumber}
            </Form.Control.Feedback>
          </Form.Group>
          <Form.Group className="mb-3">
            <Form.Label>Patient Initials</Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter patient initials"
             
              name="patiet"

              value={patientInitials}
              onChange={(e) => {
                setPatientInitials(e.target.value);
                
              }}
              maxLength={30}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer className="d-flex justify-content-around">
          <span className="cancel-btn" onClick={handleClose1}>
            Cancel
          </span>
          <Button
            variant="primary"
            className="model-btn"
            onClick={(e) => submitHandler(e)}
          >
            Reserve
          </Button>
        </Modal.Footer>
      </Modal>
      {/* End Model */}
      <div className="available-card shadow p-4 mb-5 bg-white rounded">
        <Row xs={1} sm={2} md={4} className="g-4">
          {availableBeds &&
            availableBeds.map((bed) => (
              <Col key={bed?._id}>
                <Card>
                  <Card.Body>
                    <div className="d-flex card-top">
                      <Card.Img
                        variant="left"
                        className="p-2"
                        style={{ width: "64px" }}
                        src={greenBed}
                      />
                      <Card.Title
                        style={{
                          fontSize: "15px",
                          marginTop: "14px",
                          fontWeight: "800",
                          marginLeft: "4px",
                        }}
                      >
                        Available
                      </Card.Title>
                      {/* <div style={{ float: "right" }}>
                    <Dropdown align="end">
                      <Dropdown.Toggle variant="none">
                        <ThreeDotsVertical />
                      </Dropdown.Toggle>

                      <Dropdown.Menu>
                        <Dropdown.Item href="#">Audit Trails</Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </div> */}
                    </div>
                    <div className="group-body">
                      <span className="btn1 me-2" onClick={handleShow}>
                        Occupy
                      </span>
                      <span className="btn2" onClick={handleShow1}>
                        Reserve
                      </span>
                    </div>
                  </Card.Body>
                </Card>
              </Col>
            ))}
        </Row>
      </div>
      <ApiResponsePopup
        {...{
          hideHandlerRes,
          isRecordAdded: isShow,
          successMsg: "",
          errorRes: apiError?.message,
        }}
      />
    </>
  );
};

export default AvailableBeds;
